/**
 * FinalRequestDocument permissions — distinct from advisory collection_final_request_prep:*.
 * Send is system-only (Batch 3-C) — no final_request:send human capability in this stream.
 */

export const FINAL_REQUEST_READ_PERMISSION = 'final_request:read' as const;
export const FINAL_REQUEST_DRAFT_PERMISSION = 'final_request:draft' as const;
export const FINAL_REQUEST_SUBMIT_PERMISSION = 'final_request:submit' as const;
export const FINAL_REQUEST_APPROVE_PERMISSION = 'final_request:approve' as const;

export const FINAL_REQUEST_PERMISSIONS = [
  FINAL_REQUEST_READ_PERMISSION,
  FINAL_REQUEST_DRAFT_PERMISSION,
  FINAL_REQUEST_SUBMIT_PERMISSION,
  FINAL_REQUEST_APPROVE_PERMISSION,
] as const;

export type FinalRequestPermission = (typeof FINAL_REQUEST_PERMISSIONS)[number];

export function isFinalRequestPermission(permission: string): permission is FinalRequestPermission {
  return (FINAL_REQUEST_PERMISSIONS as readonly string[]).includes(permission);
}
